import React, { useRef } from 'react';

const CardReavaliacaoMedica = ({ infoCard }) => {

  return (
    <>
      <div className='card card-reavaliacao-medica'>
        <div className='card-header'>
          <div className='card-title'>Pacientes Aguardando Reavaliação Médica</div>
          <div className='card-total'>{infoCard.totalPacientes}</div>
          <div className='card-grupo'>
						<div className={'card-tipo card-adulto ' + infoCard.corAdulto}>
              <span className='card-tipo-desc'>PS Adulto</span>
              <span className='card-tipo-total'>{infoCard.totalAdulto}</span>
            </div>
						<div className={'card-tipo card-infantil ' + infoCard.corInfantil}>
              <span className='card-tipo-desc'>PS Infantil</span>
              <span className='card-tipo-total'>{infoCard.totalInfantil}</span>
            </div>
          </div>
          <div className='card-status'>
            <div className='card-grupo'>
              <span className='card-status-desc'>Maior tempo aguardando</span>
              <span className='card-status-tempo'>{infoCard.maiorTempo}</span>
            </div>
						<div className={"card-status-bar " + infoCard.corMaiorTempo}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardReavaliacaoMedica;